import { render, staticRenderFns } from "./inventoryInquiry.vue?vue&type=template&id=71353794&scoped=true"
import script from "./inventoryInquiry.vue?vue&type=script&lang=js"
export * from "./inventoryInquiry.vue?vue&type=script&lang=js"
import style0 from "./inventoryInquiry.vue?vue&type=style&index=0&id=71353794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71353794",
  null
  
)

export default component.exports